import {Typography} from "@mui/material"
import {Box, Stack} from "@mui/system"
import {FC} from "react"
import {BackArrowIcon, CloseIcon} from "../../../assets"
import {Tooltip} from "../../atoms"

type Props = {
  toolTipText: string
  onBackClick?: () => void
  onCloseClick?: () => void
}

const ExpertBioNavigation: FC<Props> = (props) => {
  const {toolTipText, onBackClick, onCloseClick} = props

  const handleBackClick = () => {
    onBackClick && onBackClick()
  }

  const handleCloseClick = () => {
    onCloseClick && onCloseClick()
  }

  return (
    <Stack component={"div"} direction="row" sx={{width: "100%"}}>
      <Tooltip title={toolTipText}>
        <Box
          sx={{
            flexGrow: 0,
            display: "flex",
            justifyContent: "flex-start",
            flexDirection: "row",
            cursor: "pointer",
            padding: "8px 0px 8px 0px",
            width: "24px",
          }}
          onClick={handleBackClick}
        >
          <BackArrowIcon
            fill="#053747"
            height={"24px"}
            width={"24px"}
            style={{marginLeft: "-6.3px"}}
          />
        </Box>
      </Tooltip>
      <Stack
        direction={"row"}
        sx={{
          width: "95%",
          height: "100%",
          flexGrow: 0,
          display: "flex",
          justifyContent: "flex-start",
          flexDirection: "row",
          alignItems: "flex-start",
        }}
      >
        <Box
          sx={{
            width: "90%",
            padding: "8px 0px 8px 0px",
          }}
        >
          <Typography
            align={"left"}
            sx={{
              flexGrow: 0,
              fontFamily: "Open Sans",
              fontSize: "20px",
              fontWeight: 600,
              fontStretch: "normal",
              fontStyle: "normal",
              lineHeight: 1.2,
              letterSpacing: "normal",
              color: "#242d35",
              margin: "0px",
            }}
          >
            {"Expert bio"}
          </Typography>
        </Box>
        <Box
          sx={{
            width: "10%",
            cursor: "pointer",
            padding: "8px",
          }}
          onClick={handleCloseClick}
        >
          <CloseIcon fill="#595958" />
        </Box>
      </Stack>
    </Stack>
  )
}

export default ExpertBioNavigation
